import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import HomePage from "@/pages/HomePage";
import FeaturesPage from "@/pages/FeaturesPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";

const TITLES = {
  "/": "BoostPro — Gestion clients, factures et dépenses",
  "/fonctionnalites": "Fonctionnalités — BoostPro",
  "/privacy": "Politique de confidentialité — BoostPro",
  "/terms": "Conditions d'utilisation — BoostPro",
  "/contact": "Contact — BoostPro",
};

function RouteEffects() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    document.title = TITLES[location.pathname] || "BoostPro";
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#060B14] text-slate-200">
      <BrowserRouter>
        <RouteEffects />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/fonctionnalites" element={<FeaturesPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "rgba(15, 23, 42, 0.95)",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#E2E8F0",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
